class timelineComponent extends SliderComponent {
  constructor() {
    super();
    this.DATE_ACTIVE_CLASS = "timeline__date--active";
    this.timeline = this.wrapper.querySelector("[data-slider-dates]");
    this.timelineDates = this.wrapper.querySelectorAll("[data-slider-date]");
    this.setDate();
    this.slider.addEventListener("scroll", () => this.setDate());
  }

  /**
   * Set and scroll to active date if a timeline.
   */
  setDate() {
    if (!this.timeline) return;

    this.timelineDates.forEach(date => {
      const index = parseInt(date.dataset.index);
      const isActive = index === this.currentPage - 1;
      const leftPos = date.offsetLeft;

      date.classList.toggle(this.DATE_ACTIVE_CLASS, isActive);
      date.setAttribute("aria-current", isActive ? "true" : "false");

      if(isActive) {
        this.timeline.scrollLeft = leftPos - 20;
      }
    });
  }
}

customElements.define('timeline-component', timelineComponent);